<sw-sidebar-item
    class="neti-ior-cart-sidebar-filter-item"
    icon="regular-filter"
    :title="$t('neti-incomplete-order-reminder.list.sidebar-filter.titleSidebarFilter')"
    :badge="filterCount"
>
    <template #headline-content>
        <a
            v-if="filterCount > 0"
            @click="onResetFilters"
        >
            {{ $t('sw-sidebar-filter-panel.resetButton') }}
        </a>
    </template>

    <div class="neti-ior-cart-sidebar-filter">
        {% block neti_ior_cart_sidebar_filter_container_name %}
            <sw-container
                columns="1fr 1fr"
                gap="15px"
            >
                {% block neti_ior_cart_sidebar_filter_first_name %}
                    <sw-field
                        v-if="acl.can('customer.view')"
                        type="text"
                        v-model:value="filter.firstName"
                        :label="$t('neti-incomplete-order-reminder.list.sidebar-filter.firstNameLabel')"
                        @update:value="onUpdateFilters"
                    ></sw-field>
                {% endblock %}

                {% block neti_ior_cart_sidebar_filter_last_name %}
                    <sw-field
                        v-if="acl.can('customer.view')"
                        type="text"
                        v-model:value="filter.lastName"
                        :label="$t('neti-incomplete-order-reminder.list.sidebar-filter.lastNameLabel')"
                        @update:value="onUpdateFilters"
                    ></sw-field>
                {% endblock %}
            </sw-container>
        {% endblock %}

        {% block neti_ior_cart_sidebar_filter_mailed %}
            <mt-select
                v-model="filter.mailed"
                :label="$t('neti-incomplete-order-reminder.list.sidebar-filter.mailedLabel')"
                @update:model-value="onUpdateFilters"
                :options="mailedOptions"
            ></mt-select>
        {% endblock %}

        {% block neti_ior_cart_sidebar_filter_container_value %}
            <sw-container
                columns="1fr 1fr"
                gap="15px"
            >
                {% block neti_ior_cart_sidebar_filter_value_from %}
                    <mt-number-field
                        v-model="filter.value.from"
                        :label="$t('neti-incomplete-order-reminder.list.sidebar-filter.valueFromLabel')"
                        number-type="float"
                        :min="0"
                        allowEmpty
                        @update:model-value="onUpdateFilters"
                    ></mt-number-field>
                {% endblock %}

                {% block neti_ior_cart_sidebar_filter_value_to %}
                    <mt-number-field
                        v-model="filter.value.to"
                        :label="$t('neti-incomplete-order-reminder.list.sidebar-filter.valueToLabel')"
                        number-type="float"
                        :min="0"
                        allowEmpty
                        @update:model-value="onUpdateFilters"
                    ></mt-number-field>
                {% endblock %}
            </sw-container>
        {% endblock %}

        {% block neti_ior_cart_sidebar_filter_container_created %}
            <sw-container
                columns="1fr 1fr"
                gap="15px"
            >
                {% block neti_ior_cart_sidebar_filter_created_from %}
                    <mt-datepicker
                        v-model="filter.createdAt.from"
                        :label="$t('neti-incomplete-order-reminder.list.sidebar-filter.createdFromLabel')"
                        @update:model-value="onUpdateFilters"
                    ></mt-datepicker>
                {% endblock %}

                {% block neti_ior_cart_sidebar_filter_created_to %}
                    <mt-datepicker
                        v-model="filter.createdAt.to"
                        :label="$t('neti-incomplete-order-reminder.list.sidebar-filter.createdToLabel')"
                        @update:model-value="onUpdateFilters"
                    ></mt-datepicker>
                {% endblock %}
            </sw-container>
        {% endblock %}
    </div>
</sw-sidebar-item>